import { render, staticRenderFns } from "./PromotionsJackpotDetails.vue?vue&type=template&id=3c5b24d2&scoped=true"
import script from "./PromotionsJackpotDetails.vue?vue&type=script&lang=js"
export * from "./PromotionsJackpotDetails.vue?vue&type=script&lang=js"
import style0 from "./PromotionsJackpotDetails.vue?vue&type=style&index=0&id=3c5b24d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5b24d2",
  null
  
)

export default component.exports